module.exports = __webpack_public_path__ + "images/init-stars-projects@2x-e5eb9dfec17b8ba5fff6a42a62a1fbaf.png";